<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <BasicCell :span="1" />
    <BasicCell :span="1" />
    <BasicCell :span="1" />
    <BasicCell
      :span="3"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Numéro</span>
    </BasicCell>
    <BasicCell
      :span="12"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dispositif"
      />
      <span>Dispositif</span>
    </BasicCell>
    <BasicCell :span="9">
      <span>Entreprise</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="statut"
      />
      <span>Etat</span>
    </BasicCell>
    <BasicCell :span="4" />
  </div>
</template>

<script setup lang="ts">
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'

  const modelValue = defineModel<string>()
</script>
